import { api } from '../../DefaultService';
import { IResponsibleFilterProps } from '../../ResponsibleService/types';
import { IPaginationParams, ISelectionOption } from '../../types';
import {
  IResponsibleRecognitionCreateProps,
  IResponsibleRecognitionProps,
  IResponsibleRecognitionSimpleProps,
  IResponsibleRecognitionUpdateParams,
} from './types';

const ENDPOINT = 'v1/recognitions/responsible';

export const createResponsibleRecognitionAsync = async (
  data: IResponsibleRecognitionCreateProps,
): Promise<IResponsibleRecognitionProps> => {
  try {
    const res = await api.post(`${ENDPOINT}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 0, // desativa timeout nesta request
    });
    return res.data;
  } catch (error: any) {
    throw new Error(
      error?.response?.data?.userMessage || 'Erro interno do servidor!',
    );
  }
};

export const updateResponsibleRecognitionAsync = async ({
  id,
  data,
}: IResponsibleRecognitionUpdateParams): Promise<IResponsibleRecognitionProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const getResponsibleRecognitionByIdAsync = async (
  id: number,
): Promise<IResponsibleRecognitionProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const getAllResponsibleByLicenseAsync = async (
  pagination?: IPaginationParams,
  filter?: IResponsibleFilterProps,
): Promise<IResponsibleRecognitionSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const getAllResponsiblesForSelectionAsync = async (): Promise<ISelectionOption[]> => {
  try {
    const response = await api.get(`${ENDPOINT}/selection`); 
    return response.data;
  } catch (error) {
    throw new Error('Erro ao buscar lista de responsáveis.');
  }
};
